import React from 'react';

import {
  List as ListUI,
  ListItem,
  ListItemIcon,
  Checkbox,
  ListItemText,
  TextField,
} from '@material-ui/core';
import { find, isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import { t } from '~/helpers';

import * as S from './styles';

export default function List({
  data,
  unique,
  onChangeItem,
  checkeds,
  label,
  edit,
  onEditItem,
}) {
  const [search, setSearch] = React.useState('');

  // Search items in array
  const handleSearchItem = React.useCallback((value) => {
    setSearch(value);
  }, []);

  return (
    <S.WrapperContainer>
      <TextField
        fullWidth
        size="small"
        variant="outlined"
        label={t('s.geral.pesquisar')}
        onChange={({ target }) => handleSearchItem(target.value)}
      />

      <S.Wrapper>
        <ListUI dense component="div" role="list">
          {!isEmpty(data) &&
            data
              .filter((item) => item[label].toLowerCase().indexOf(search) > -1)
              .map((item, index) => (
                <ListItem
                  dense
                  disableGutters
                  key={`list-item-${item[unique]}`}
                  role="listitem"
                >
                  <ListItemIcon onClick={() => onChangeItem(item)}>
                    <Checkbox
                      disableTouchRipple
                      checked={!!find(checkeds, item)}
                      tabIndex={-1}
                    />
                  </ListItemIcon>

                  {edit ? (
                    <S.WrapperInput>
                      <p>{item[label]}</p>
                      <TextField
                        variant="outlined"
                        size="small"
                        label={t(
                          's.cadastro.modeloveiculo.consumomediomodeloveiculo'
                        )}
                        defaultValue={item.consumomediomodeloveiculooperacao}
                        onChange={({ target }) =>
                          onEditItem(index, target.value)
                        }
                        type="number"
                      />
                    </S.WrapperInput>
                  ) : (
                    <ListItemText primary={item[label]} />
                  )}
                </ListItem>
              ))}
        </ListUI>
      </S.Wrapper>
    </S.WrapperContainer>
  );
}

List.propTypes = {
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  unique: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChangeItem: PropTypes.func.isRequired,
  checkeds: PropTypes.arrayOf(PropTypes.any).isRequired,
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  edit: PropTypes.bool,
  onEditItem: PropTypes.func,
};

List.defaultProps = {
  edit: false,
  onEditItem: () => undefined,
};
